import { useEffect, useRef } from 'react';
import { BUSINESS_INFO } from '../data';
import { useLang } from '../context/LangContext';

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const scrollTo = (id, e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{
      background: 'linear-gradient(160deg, #1A1218 0%, #2A1820 50%, #130D15 100%)',
      color: '#fff',
      padding: '6rem clamp(1.25rem,5vw,6rem) 2.5rem',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Decorative blobs */}
      <div style={{
        position: 'absolute', width: '500px', height: '500px',
        background: 'radial-gradient(ellipse, rgba(183,110,121,0.12) 0%, transparent 70%)',
        top: '-100px', right: '-100px', borderRadius: '50%', pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', width: '300px', height: '300px',
        background: 'radial-gradient(ellipse, rgba(232,180,184,0.06) 0%, transparent 70%)',
        bottom: 0, left: '10%', borderRadius: '50%', pointerEvents: 'none',
      }} />

      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="grid-3-col" style={{ paddingBottom: '4rem', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          {/* Brand */}
          <div>
            <div style={{ fontFamily: 'var(--font-serif)', fontSize: '1.6rem', fontWeight: 500, marginBottom: '1.25rem' }}>
              ISHA <span style={{ color: '#E8B4B8' }}>BOUTIQUE</span>
            </div>
            <p style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.55)', lineHeight: 1.75, maxWidth: '260px', marginBottom: '2rem' }}>
              {t.footerDesc}
            </p>
            {/* Social links */}
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              {[
                { label: 'Facebook', href: BUSINESS_INFO.facebook, icon: '📘' },
                { label: 'WhatsApp', href: `https://wa.me/${BUSINESS_INFO.whatsappRaw}`, icon: '💬' },
                { label: 'Messenger', href: BUSINESS_INFO.messenger, icon: '📨' },
              ].map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  style={{
                    width: '38px', height: '38px', borderRadius: '10px',
                    background: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '1rem', textDecoration: 'none',
                    transition: 'transform 0.3s ease, background 0.3s ease, border-color 0.3s ease',
                  }}
                  onMouseOver={e => {
                    e.currentTarget.style.transform = 'translateY(-3px) scale(1.1)';
                    e.currentTarget.style.background = 'rgba(183,110,121,0.2)';
                    e.currentTarget.style.borderColor = 'rgba(183,110,121,0.4)';
                  }}
                  onMouseOut={e => {
                    e.currentTarget.style.transform = 'none';
                    e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                  }}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Collections */}
          <div>
            <div className="heading-sub" style={{ color: 'rgba(255,255,255,0.35)', marginBottom: '1.25rem' }}>
              {t.footerCollections}
            </div>
            {['Sarees', 'Lehengas', 'Designer Suits', 'Kurtas & Menswear', 'Party Gowns'].map(item => (
              <a
                key={item}
                href="#collections"
                onClick={e => scrollTo('collections', e)}
                style={{
                  display: 'block', fontSize: '0.88rem',
                  color: 'rgba(255,255,255,0.55)', padding: '0.3rem 0',
                  transition: 'color 0.25s, transform 0.25s',
                }}
                onMouseOver={e => { e.target.style.color = '#E8B4B8'; e.target.style.transform = 'translateX(4px)'; }}
                onMouseOut={e  => { e.target.style.color = 'rgba(255,255,255,0.55)'; e.target.style.transform = 'none'; }}
              >
                {item}
              </a>
            ))}
          </div>

          {/* Contact */}
          <div>
            <div className="heading-sub" style={{ color: 'rgba(255,255,255,0.35)', marginBottom: '1.25rem' }}>
              {t.footerContact}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <a href={`tel:${BUSINESS_INFO.phoneRaw}`} style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.65)', transition: 'color 0.25s' }}
                onMouseOver={e => e.target.style.color = '#E8B4B8'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.65)'}>
                📞 {BUSINESS_INFO.phone}
              </a>
              <a href={`https://wa.me/${BUSINESS_INFO.whatsappRaw}`} target="_blank" rel="noopener noreferrer"
                style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.65)', transition: 'color 0.25s' }}
                onMouseOver={e => e.target.style.color = '#25D366'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.65)'}>
                💬 +39 329 425 8480 (WhatsApp)
              </a>
              <a href={BUSINESS_INFO.facebook} target="_blank" rel="noopener noreferrer"
                style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.65)', transition: 'color 0.25s' }}
                onMouseOver={e => e.target.style.color = '#90CAF9'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.65)'}>
                📘 Facebook Page
              </a>
              <a href="#visit" onClick={e => scrollTo('visit', e)}
                style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.65)', transition: 'color 0.25s' }}
                onMouseOver={e => e.target.style.color = '#E8B4B8'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.65)'}>
                📍 {BUSINESS_INFO.address}, {BUSINESS_INFO.city}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          paddingTop: '2rem', display: 'flex', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: '0.5rem',
          fontSize: '0.72rem', color: 'rgba(255,255,255,0.28)',
        }}>
          <span>© {year} {BUSINESS_INFO.name} · {BUSINESS_INFO.city}</span>
          <span>Traditional South Asian Fashion · Mestre, Venice 🇮🇹</span>
        </div>
      </div>
    </footer>
  );
}
